































import {ChartDataTemplate, FCCategory, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import WidgetFrame from "@/components/WidgetFrame.vue"
import {executeQuery} from "@/data/repos/query"
import {bus} from "@/main"
import LoadingSpinner from "@/components/LoadingSpinner.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {defineComponent, reactive, watch} from "@vue/composition-api"
import {deepMerge} from "@/utils"
import {fusionDataFetcher, setupConfigWatcher, setupParamWatcher} from "@/components/widgets/WidgetMother"
import {getLocationCaption} from "@/data/sources/appraisal"

export function getWidgetConfig(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "LocationCount",
    title: "Locations count",
    cType: FCCategory.Custom,
    w: 2,
    h: 2,
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

export default defineComponent({
  props: {config: {required: true}},
  components: {LoadingSpinner, WidgetFrame},
  setup(p, ctx) {
    ctx.emit("config-update", getWidgetConfig())
    const config = reactive(deepMerge({}, p.config) || {})
    const chartConfig = reactive({width: 0, height: 0, title: ""})
    const chartDS = reactive({loaded: false})

    const dataFetcher = async (params: any) => {
      chartDS.loaded = false
      if (isNaN(parseInt(params.locationId.value))) {
        return {loaded: false}
      }
      const r = await executeQuery("idr", "locationCountNew", {location_id: params.locationId.value})
      if (r) {
        const value = r[0]
        return {
          loaded: true,
          regionCount: formatNumberWithGrouping(value['Regions'], 0),
          siteCount: formatNumberWithGrouping(value['Sites'], 0),
          buildingCount: formatNumberWithGrouping(value['Buildings'], 0),
          floorCount: formatNumberWithGrouping(value['Floors'], 0),
          roomCount: formatNumberWithGrouping(value['Rooms'], 0),
        }
      }
    }

    function showDrillDown(locationTitle: string, locationType: string) {
      bus.$emit("chartPopup", {
        title: locationTitle + " details",
        component: () => import("@/components/widgets/core/LocationCountDrillDown.vue"),
        componentArgs: {locationType},
      })
    }

    const fetchData = fusionDataFetcher(dataFetcher as (params: any) => any)
    const chartDataConfig = reactive(ChartDataTemplate())
    const titleCallback = async (config: any) => chartConfig.title = "Location: " + await getLocationCaption(config.params.locationId)
    watch(() => p.config, (c) => deepMerge(config, c), {deep: true})
    setupParamWatcher(fetchData, chartDS, chartDataConfig, config)
    setupConfigWatcher(config, chartConfig, chartDataConfig, titleCallback)
    return {chartDS, chartConfig, showDrillDown}
  },
})
